import React from 'react';
import { Trans } from 'react-i18next';
import { Url } from '@wix/da-url';
import { ReferralType } from '@wix/da-bi/pkg/constants';
import BiLink from '@wix/da-bi/pkg/Components/BiLink';
import { BiData, RedirectToLoginBiEvent } from '@wix/da-bi/pkg/events';

import s from './CommentForAnonymous.scss';

export interface Props {
  /**
   * When true, the message is a single button (no links) so a parent {@link SisuActionPopover}
   * can handle clicks without navigating away.
   */
  asSisuPopoverTrigger?: boolean;
}

const CommentForAnonymous: React.FC<Props> = ({ asSisuPopoverTrigger = false }) => {
  const message = (
    <Trans i18nKey="commentbox.anonymous.message" parent="span">
      {asSisuPopoverTrigger ? (
        <span className={s.link}>Join the community</span>
      ) : (
        <BiLink
          href={Url.joinLink()}
          className={s.link}
          biData={BiData<RedirectToLoginBiEvent>({
            evid: 240,
            referral_info: ReferralType.COMMENT,
          })}
        >
          Join the community
        </BiLink>
      )}
      {' to add your comment. Already a deviant? '}
      {asSisuPopoverTrigger ? (
        <span className={s.link}>Sign In</span>
      ) : (
        <a href={Url.loginLink()} className={s.link}>
          Sign In
        </a>
      )}
    </Trans>
  );

  if (asSisuPopoverTrigger) {
    return (
      <button type="button" className={s.root}>
        {message}
      </button>
    );
  }

  return <div className={s.root}>{message}</div>;
};

CommentForAnonymous.displayName = 'CommentForAnonymous';
export default CommentForAnonymous;
